var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-modification-recordtable"},[_c('BaseTable',{attrs:{"loading":_vm.loading,"config":_vm.config,"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }